import React, { useEffect, useState } from "react";
import styles from "./EventsAtAptech.module.scss";
import EventsAptechBannerFirst from "../../assets/images/EventsAptechBannerFirst.jpg";
import EventsAtAptechBannerSecond from "../../assets/images/EventsAtAptechBannerSecond.jpg";
import EventsAtaptechBannerThird from "../../assets/images/EventsAtaptechBannerThird.jpg";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import EventAtMaacImg1 from "../../assets/images/MaacEventCardImg1.jpg";
import EventAtMaacImg2 from "../../assets/images/MaacEventCardImg2.jpg";
import EventAtMaacImg3 from "../../assets/images/MaacEventCardImg3.jpg";
import EventAtMaacImg4 from "../../assets/images/MaacEventCardImg4.png";
import EventAtMaacImg5 from "../../assets/images/MaacEventCardImg5.png";
import EventAtMaacImg6 from "../../assets/images/MaacEventCardImg6.png";
import EventAtLakmeImg1 from "../../assets/images/EventAtLakmeImg1.jpg";
import EventAtLakmeImg2 from "../../assets/images/EventAtLakmeImg2.jpg";
import EventAtArenaImg1 from "../../assets/images/EventAtArenaImg1.jpg";
import EventAtArenaImg2 from "../../assets/images/EventAtArenaImg2.jpg";
import EventAtArenaImg3 from "../../assets/images/EventAtArenaImg3.jpg";
import EventAtArenaImg4 from "../../assets/images/EventAtArenaImg4.png";
import EventAtArenaImg5 from "../../assets/images/EventAtArenaImg5.png";
import EventAtArenaImg6 from "../../assets/images/EventAtArenaImg6.png";

// EventAtLakmeImg1.png
import EventsCards from "../CustomComponent/EventsCards.tsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "../../assets/Icons.tsx";

const EventsAtAptech: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Events at Aptech", link: "/events-at-aptech" },
  ];
  return (
    <div className={`${styles.EventsAtAptech} section`}>
      <BreadCrumb menu={breadcrumb} />
      <Banner />
      <EventAtGlance />
      <EventAtMaac />
      <EventAtArena />
      <EventAtLakme />
    </div>
  );
};

export default EventsAtAptech;

const Banner: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col-12 ">
          <p className="heading text-center">Events at Aptech</p>
          <p className="para text-center">
            At Aptech, learning extends beyond the classrooms!
          </p>
          <p className="para text-center">
            Events at Aptech are designed to enrich the student experience,
            offering practical exposure, industry insights, and opportunities to
            network with professionals from industries spanning across aviation,
            hospitality, IT, finance, animation, gaming, VFX, and beauty and
            wellness.
          </p>
          <p className="para text-center">
            From program specific workshops and seminars to industrial tours and
            events like award nights and felicitation ceremonies, Aptech
            provides a dynamic environment for students to develop their skills
            and build meaningful connections.
          </p>
        </div>
        {isMobile ? (
          <div className="row mt-4 ">
            <div className="col-md-12 d-flex justify-content-center">
              <img
                src={EventsAtAptechBannerSecond}
                alt="EventsAtAptechBannerSecond"
                className={`${styles.bannerImgTwoMob}`}
              />
            </div>
            <div className="col-md-12 d-flex justify-content-center">
              <div className="col-md-6 d-flex justify-content-center">
                <img
                  src={EventsAptechBannerFirst}
                  alt="EventsAptechBannerFirst"
                  className={`${styles.bannerImgOneMob}`}
                />
              </div>
              <div className="col-md-6 d-flex justify-content-center">
                <img
                  src={EventsAtaptechBannerThird}
                  alt="EventsAtaptechBannerThird"
                  className={`${styles.bannerImgThreeMob}`}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="row mt-4">
            <div className="col-lg-4 d-flex justify-content-center">
              <img
                src={EventsAptechBannerFirst}
                alt="EventsAptechBannerFirst"
                className={`${styles.bannerImgOne} img-fluid`}
              />
            </div>
            <div className="col-lg-4 d-flex justify-content-center">
              <img
                src={EventsAtAptechBannerSecond}
                alt="EventsAtAptechBannerSecond"
                className={`${styles.bannerImgTwo} img-fluid`}
              />
            </div>
            <div className="col-lg-4 d-flex justify-content-center">
              <img
                src={EventsAtaptechBannerThird}
                alt="EventsAtaptechBannerThird"
                className={`${styles.bannerImgThree} img-fluid`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const EventAtGlance: React.FC = () => {
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col-12">
          <p className="heading">Events at a glance</p>
          <p className="para">
            Aptech hosts a series of events throughout the year across all its
            brands, celebrating excellence at every level. These events honour
            student achievements, acknowledge alumni for their remarkable
            contributions as professionals and independent entrepreneurs, and
            recognize mentors for their continuous guidance and dedication to
            shaping successful careers of millions of individuals worldwide.
          </p>
        </div>
      </div>
    </div>
  );
};

const EventAtMaac: React.FC = () => {
  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.prevArrow} onClick={onClick}>
      <Icon name="backArrowIcon" />
    </div>
  );

  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.nextArrow} onClick={onClick}>
      <Icon name="forwardArrowIcon" />
    </div>
  );

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1080, // Tablet and small desktops
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767, // Mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  interface EventAtMaac {
    image: string;
    description: string;
    title: string;
  }

  const eventAtMaac: EventAtMaac[] = [
    {
      image: EventAtMaacImg1,
      description:
        "The event is a platform to showcase talent and creativity of MAAC students as well as of animators, VFX artists, and filmmakers from the film and animation industry. ",
      title: "MAAC 24FPS",
    },
    {
      image: EventAtMaacImg2,
      description:
        "This is an intense and exciting filmmaking competition, where participants create a 20-25 second short 3D animated film or a 1-minute mobile film within a 100-hour timeframe. ",
      title: "MAAC 100 Hours",
    },
    {
      image: EventAtMaacImg3,
      description: `Every year, MAAC recognizes and awards students and alumni for their successful careers at this prestigious event. `,
      title: "MAAC Manifest",
    },
    {
      image: EventAtMaacImg4,
      description:
        "MAAC students from different parts of India come together at NSM to participate in seminars, hands-on workshops, panel discussions, and, exciting fun activities.",
      title: "National Students' Meet (NSM) ",
    },
    {
      image: EventAtMaacImg5,
      description:
        "The event allows students to showcase their creativity to a great extent and get recognized for the same.",
      title: "MAAC Creative League (MCL)",
    },
    {
      image: EventAtMaacImg6,
      description: `This is a guided nature and wildlife expedition organized for MAAC students. The workshops take place in different locations across India like Coorg, Sariska National Park, and Ranthambore National Park.`,
      title: "MAAC Klick",
    },
  ];
  return (
    <div className="container ">
      <div className="row mt-lg-5 mt-md-3">
        <div className={`col-lg-12 ${styles.infoDiv}`}>
          <p className="heading col-lg-4">Events at a maac</p>
          <p className="para col-lg-8">
            The team at MAAC works round the year to organize events across
            various locations in India and overseas. 
          </p>
        </div>
        <Slider {...sliderSettings} className="mt-2 mb-2">
          {eventAtMaac.map((event, index) => (
            <div key={index}>
              <div className="ads-slider-card mt-5 m-2">
                <EventsCards
                  eventsImage={event.image}
                  description={event.description}
                  title={event.title}
                  color="#DB6516"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const EventAtArena: React.FC = () => {
  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.prevArrow} onClick={onClick}>
      <Icon name="backArrowIcon" />
    </div>
  );

  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.nextArrow} onClick={onClick}>
      <Icon name="forwardArrowIcon" />
    </div>
  );
  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1080, // Tablet and small desktops
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767, // Mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  interface EventAtArena {
    image: string;
    description: string;
    title: string;
  }

  const eventAtMaac: EventAtArena[] = [
    {
      image: EventAtArenaImg1,
      description:
        "This is a 4-day event that aims to maximize students’ learnings and enhance their skills through workshops, seminars, and master classes.",
      title: "Orbit Live",
    },
    {
      image: EventAtArenaImg2,
      description:
        "This is a student festival that celebrates India’s rich culture through arts, crafts, cultural performances, and contests.",
      title: "Kalakari ",
    },
    {
      image: EventAtArenaImg3,
      description: `This is a live platform where stalwarts from the media industry come and share interesting insights on their experiences of working in this industry.`,
      title: "Perspectives",
    },
    {
      image: EventAtArenaImg4,
      description:
        "This is an exclusive forum for students to showcase their skills, compete with peers, and apply their skills in their respective areas of specialization and gain feedback from industry leaders.",
      title: "Creative Minds  ",
    },
    {
      image: EventAtArenaImg5,
      description:
        "This is a unique event exclusively designed for Arena Animation students, combining learning with fun-filled and engagement-driven sessions. The event takes place in scenic locations of India.",
      title: "National Students Meet ",
    },
    {
      image: EventAtArenaImg6,
      description: `This is a series of free workshops and demo classes held at all Arena Animation centres to provide insights on the functioning of the media and entertainment industry.`,
      title: "Animation Camp ",
    },
  ];

  return (
    <div className="container">
      <div className="row mt-5">
        <div className={`col-lg-12 ${styles.infoDiv}`}>
          <p className="heading col-lg-4">Events at Arena</p>
          <p className="para col-lg-8">
            Arena Animation believes in going beyond the classroom to nurture
            talent, inspire innovation, and build a sense of community.
          </p>
        </div>
        <Slider {...sliderSettings} className="mt-2">
          {eventAtMaac.map((event, index) => (
            <div key={index}>
              <div className="ads-slider-card mt-5 m-2">
                <EventsCards
                  eventsImage={event.image}
                  description={event.description}
                  title={event.title}
                  color="#DB6516"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const EventAtLakme: React.FC = () => {
  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.prevArrow} onClick={onClick}>
      <Icon name="backArrowIcon" />
    </div>
  );

  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <div className={styles.nextArrow} onClick={onClick}>
      <Icon name="forwardArrowIcon" />
    </div>
  );
  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1080, // Tablet and small desktops
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767, // Mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  interface EventAtLakme {
    image: string;
    description: string;
    title: string;
  }

  const eventAtLakme: EventAtLakme[] = [
    {
      image: EventAtLakmeImg1,
      description:
        "This is one of the biggest mega-beauty championships where students participate in three major categories- makeup, skin, and nails.",
      title: "The Showcase",
    },
    {
      image: EventAtLakmeImg2,
      description:
        "This is one of the most coveted competitions that provides an equal opportunity for students and alumni to participate in high-end fashion shoots, beauty and wellness contests, and magazine cover shoots.",
      title: "The Cover Girl",
    },
  ];
  return (
    <div className="container">
      <div className="row mt-5">
        <div className={`col-lg-12 ${styles.infoDiv}`}>
          <p className="heading col-lg-4">
            Events at Lakmē Academy Powered by Aptech
          </p>
          <p className="para col-lg-8">
            Events at Lakmē Academy are organized to give students the platform
            to showcase their skills as makeup artists, hair stylists,
            cosmetologists, beauty and wellness therapists and skin experts.
          </p>
        </div>
        {eventAtLakme.length > 2 ? (
          <Slider {...sliderSettings} className="mt-2">
            {eventAtLakme.map((event, index) => (
              <div key={index}>
                <div className="ads-slider-card mt-5 m-2 ">
                  <EventsCards
                    eventsImage={event.image}
                    description={event.description}
                    title={event.title}
                    color="#DB6516"
                  />
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="container">
            <div className={`${styles.cardMainDiv}`}>
              {eventAtLakme.map((event, index) => (
                <div key={index}>
                  <div className="row">
                    <div className="col-6">
                      <div
                        className={`${styles.eventsCardDiv} d-flex flex-column align-items-stretch`}
                      >
                        <div className={`${styles.eventsImageCont}`}>
                          <img
                            src={event.image}
                            alt="Event"
                            className={`${styles.eventsImage} img-fluid`}
                          />
                        </div>

                        <div className={styles.textInfo}>
                          <p
                            className={`${styles.title} subHeading pt-3 mb-0`}
                            style={{ color: "#DB6516" }}
                          >
                            {event.title}
                          </p>
                          <p className={`${styles.detail} para`}>
                            {event.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
